export const EVENT_TYPES = {
    LIVE_EVENT: 'LIVE_EVENT',
    UPCOMING_EVENT: 'UPCOMING_EVENT',
    STREAM_EVENT: 'STREAM_EVENT',
    UPCOMING_STREAM_EVENT: 'UPCOMING_STREAM_EVENT',
};

export const EVENT_TYPES_BY_TOP_LEVEL = {
    LIVE_EVENT: 'livenow',
    UPCOMING_EVENT: 'upcoming',
    STREAM_EVENT: 'liveStream',
    UPCOMING_STREAM_EVENT: 'upcomingLiveStream',
};
export const INPLAY_STAT_WIDGET = {
    DESTROY_INPLAY_STAT_WIDGET: 'DESTROY_INPLAY_STAT_WIDGET',
};

export const BASKET_BALL_SUPPORTED_PERIOD_CODES = ['Q1', 'Q2', 'Q3', 'Q4', 'H1', 'H2', 'OT'];
